import GlobalUserAction from './GlobalUserAction';
import './index.scss';
import WidgetsBottomCenter from './widgets-bottom-center';
import WidgetsBottomRight from './widgets-bottom-right';
export default function WidgetsA({ __globar_object = {}, globalTimestamp }: { __globar_object: any; globalTimestamp: number }) {
    const __globar_left_v2 = __globar_object?.__globar_left_v2 || [];
    const __globar_right_v2 = __globar_object?.__globar_right_v2 || [];
    const __globar_bottom_v2 = __globar_object?.__globar_bottom_v2 || [];

    return (
        <>
            <WidgetsBottomCenter __globar_bottom_v2={__globar_bottom_v2} />
            {/* <WidgetsBottomLeft __globar_left_v2={__globar_left_v2} /> */}
            <WidgetsBottomRight globalTimestamp={globalTimestamp} __globar_right_v2={__globar_right_v2} __globar_bottom_v2={__globar_bottom_v2} />
            <GlobalUserAction />
        </>
    );
}
